module.exports = __webpack_public_path__ + "static/img/use_fund_as_you_choose2.6b530ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/use_fund_as_you_choose2.png
// module id = 1807
// module chunks = 5